import { Flex } from '@chakra-ui/react';
import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { z } from 'zod';

import { CreditAgreementsViewTemplate } from '../CreditAgreementsViewTemplate';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';
import CreditAgreement from '~/packages/creditAgreements/ui/CreditAgreementView';

// Types
const RouteParamsStruct = z.object({
  implementationId: z.string({ message: 'Missing URL parameter' }),
  creditFacilityId: z.string({ message: 'Missing URL parameter' }),
  creditAgreementId: z.string({ message: 'Missing URL parameter' }),
});

// Fragments
const RouteBase = () => {
  const { user } = useUserAuthOrThrow();
  const params = useParams();
  const {
    implementationId,
    creditFacilityId,
    creditAgreementId,
  } = RouteParamsStruct.parse(params);

  // Generate path back to credit agreements list
  const creditAgreementsPath = `/implementations/${implementationId}/credit-facilities/${creditFacilityId}/credit-agreements`;

  return (
    <CreditAgreement
      organizationId={user.organization.id}
      creditAgreementId={creditAgreementId}
      creditAgreementsPath={creditAgreementsPath}
    />
  );
};

// Exports
export const Route = () => {
  return (
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/" />;
      }}
    >
      <Flex
        direction="column"
        padding={['1.5rem', '1.5rem', '1.5rem', '2.5rem']}
      >
        <CreditAgreementsViewTemplate>
          <RouteBase />
        </CreditAgreementsViewTemplate>
      </Flex>
    </RouteErrorBoundary>
  );
};
